export const incomingLikesEmptyDescription = 'Когда вы кому-то понравитесь, анкета появится здесь.';
